{
  "order": {
    "completionRule": "Completes by itself once every ordered quantity is received or closed short and at least one supplier invoice is recorded.",
    "completionCancelled": "A cancelled order ends here. It does not complete.",
    "cancelledQuantity": "Not delivered (cancelled)",
    "cancelledNotice": {
      "title": "This order is cancelled",
      "body": "Nothing further is expected on it, and no more receipts can be recorded. What arrived stays recorded as received; the rest, shown below as not delivered, was cancelled."
    }
  }
}
